/*
 * Keep the collection's template across in-page re-renders.
 *
 * Intelligems' template test picks the template on the first load and then
 * removes its own parameters from the URL, so the address bar carries no
 * record of which template is being shown. The collection page re-renders
 * itself by refetching window.location.href — sorting, tag filters, load more
 * — and that request resolves to the DEFAULT template. The shopper sorts by
 * price and the test variant silently disappears, while Intelligems still
 * counts them in the variant.
 *
 * The page knows which template rendered it (Liquid wrote it into
 * data-collection-template-suffix), so we put it back on any same-collection
 * document request that has lost it. The visible URL is left alone, which is
 * the point — Intelligems hides those parameters deliberately.
 *
 * Full page navigations need nothing: Intelligems runs again and re-applies
 * the template itself.
 */
(function () {
  var host = document.querySelector('[data-collection-template-suffix]');
  var suffix = host && host.getAttribute('data-collection-template-suffix');
  if (!suffix) return;
  if (window.__collectionTemplateKeeper) return;
  window.__collectionTemplateKeeper = true;

  function needsTemplate(rawUrl) {
    if (!rawUrl) return false;
    var url;
    try {
      url = new URL(rawUrl, window.location.origin);
    } catch (e) {
      return false;
    }
    if (url.origin !== window.location.origin) return false;
    /*
     * Any collection document, not only the one we are standing on. The
     * All / Men's / Women's tabs fetch a DIFFERENT collection, and that is
     * exactly the moment the arm was being lost; the same applies to sorting
     * after such a switch, since the path has changed by then.
     *
     * A collection with no template of that name simply falls back to the
     * default, so casting this wide costs nothing.
     */
    if (url.pathname.indexOf('/collections/') !== 0) return false;
    if (/\.(js|json|css|png|jpe?g|webp|svg|atom)$/i.test(url.pathname)) return false;
    return !url.searchParams.has('view');
  }

  function withTemplate(rawUrl) {
    var url = new URL(rawUrl, window.location.origin);
    url.searchParams.set('view', suffix);
    return url.pathname + url.search + url.hash;
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string' && needsTemplate(input)) {
          input = withTemplate(input);
        } else if (input && typeof input === 'object' && input.url && needsTemplate(input.url)) {
          input = new Request(withTemplate(input.url), input);
        }
      } catch (e) {
        /* fall through with the original request */
      }
      return originalFetch.call(this, input, init);
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (needsTemplate(url)) {
        arguments[1] = withTemplate(url);
      }
    } catch (e) {
      /* leave the request as it was */
    }
    return originalOpen.apply(this, arguments);
  };
})();
